class Product {
	constructor({
		id = '',
		code = '',
		name = '',
		usd = 0,
		krw = 0,
		discountUsd = 0,
		discountKrw = 0,
		materialCostUsd = null as number | null,
		materialCostKrw = null as number | null,
		index = 0,
		quantity = 0,
		useYn = 0,
		alwaysAvailableYn = 0,
		soldoutYn = 0,
		updatedBy = '',
		updatedAt = '',
		createdBy = '',
		createdAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.code = code === null ? '' : code
		this.name = name === null ? '' : name
		this.usd = usd === null ? 0 : usd
		this.krw = krw === null ? 0 : krw
		this.discountUsd = discountUsd === null ? 0 : discountUsd
		this.discountKrw = discountKrw === null ? 0 : discountKrw
		this.materialCostUsd =
			materialCostUsd === null || materialCostUsd === undefined
				? null
				: Number(materialCostUsd)
		this.materialCostKrw =
			materialCostKrw === null || materialCostKrw === undefined
				? null
				: Number(materialCostKrw)
		this.quantity = quantity === null ? 0 : quantity
		this.index = index === null ? 0 : index
		this.useYn = useYn === null ? 0 : useYn
		this.alwaysAvailableYn = alwaysAvailableYn === null ? 0 : alwaysAvailableYn
		this.soldoutYn = soldoutYn === null ? 0 : soldoutYn
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.createdAt = createdAt === null ? '' : createdAt
	}
	id: string
	code: string
	name: string
	usd: number
	krw: number
	discountUsd: number
	discountKrw: number
	/** 재료원가 — 정산 원가의 두 번째 출처. DISPATCH_PLAN §6.3 */
	materialCostUsd: number | null
	materialCostKrw: number | null
	index: number
	quantity: number
	useYn: number
	alwaysAvailableYn: number
	soldoutYn: number
	updatedBy: string
	updatedAt: string
	createdBy: string
	createdAt: string
}

export { Product }
